import { render, staticRenderFns } from "./ServiceIndex.vue?vue&type=template&id=48daef60"
import script from "./ServiceIndex.vue?vue&type=script&lang=js"
export * from "./ServiceIndex.vue?vue&type=script&lang=js"
import style0 from "./ServiceIndex.vue?vue&type=style&index=0&id=48daef60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports